import { LatLngAlt } from "../../../types.js";

const stream: LatLngAlt[] = [
  [-10.755474, 165.848107, 134.8],
  [-10.755459, 165.848, 134.6],
  [-10.755461, 165.847893, 134.4],
  [-10.755493, 165.847785, 134],
  [-10.755581, 165.847721, 133.4],
  [-10.755691, 165.847689, 132.8],
  [-10.755805, 165.847657, 132],
  [-10.755926, 165.847646, 131.4],
  [-10.756046, 165.847614, 130.6],
  [-10.756154, 165.847549, 130],
  [-10.756254, 165.847464, 129.6],
  [-10.756349, 165.847389, 129],
  [-10.756459, 165.847313, 128.4],
  [-10.756586, 165.847281, 127.8],
  [-10.756714, 165.847249, 127.4],
  [-10.756821, 165.847174, 127],
  [-10.756911, 165.847067, 126.6],
  [-10.757011, 165.846992, 126.4],
  [-10.757137, 165.846938, 125.8],
  [-10.757266, 165.846938, 125.4],
  [-10.757398, 165.846938, 124.8],
  [-10.757524, 165.846992, 124.4],
  [-10.757634, 165.847067, 124.2],
  [-10.757725, 165.847152, 124],
  [-10.757807, 165.84726, 123.8],
  [-10.757888, 165.847356, 123.6],
  [-10.757966, 165.847464, 123.6],
  [-10.758038, 165.847571, 123.8],
  [-10.75811, 165.847657, 124],
  [-10.758205, 165.847721, 124.2],
  [-10.758316, 165.847764, 124.2],
  [-10.758428, 165.847796, 124.2],
  [-10.75854, 165.847796, 124.2],
  [-10.758651, 165.847764, 124],
  [-10.758755, 165.847721, 123.8],
  [-10.758851, 165.847657, 123.6],
  [-10.758945, 165.847603, 123.6],
  [-10.759036, 165.847539, 123.8],
  [-10.759122, 165.847464, 124],
  [-10.759195, 165.847389, 124.2],
  [-10.759235, 165.847281, 124.2],
  [-10.759244, 165.847174, 124.2],
  [-10.759247, 165.847067, 124.2],
  [-10.759276, 165.84697, 124.2],
  [-10.759311, 165.846863, 124.2],
  [-10.75929, 165.846777, 124.2],
  [-10.759213, 165.846702, 124.2],
  [-10.759114, 165.84668, 124.2],
  [-10.75903, 165.846745, 124.2],
  [-10.758951, 165.84682, 124.2],
  [-10.758865, 165.846884, 124],
  [-10.758773, 165.846927, 123.8],
  [-10.758682, 165.84697, 123.8],
  [-10.758597, 165.847034, 123.8],
  [-10.758517, 165.84711, 124],
  [-10.758442, 165.847174, 124],
  [-10.758368, 165.847249, 124.2],
  [-10.758287, 165.847313, 124],
  [-10.758192, 165.847313, 123.6],
  [-10.758116, 165.847238, 123.4],
  [-10.758043, 165.847142, 123.2],
  [-10.757976, 165.847067, 122.8],
  [-10.757907, 165.84697, 122.6],
  [-10.757837, 165.846895, 122.2],
  [-10.757797, 165.846788, 122],
  [-10.757848, 165.84668, 122],
  [-10.757887, 165.846595, 122],
  [-10.75783, 165.846487, 122],
  [-10.757805, 165.846391, 122],
  [-10.757872, 165.846305, 122],
  [-10.757954, 165.846241, 122],
  [-10.758038, 165.846165, 122],
  [-10.758122, 165.846101, 122],
  [-10.758201, 165.846026, 122],
  [-10.75828, 165.845951, 122],
  [-10.758369, 165.845908, 122],
  [-10.758471, 165.845919, 122],
  [-10.758548, 165.845983, 122],
  [-10.758614, 165.846069, 122],
  [-10.758678, 165.846155, 122],
  [-10.758749, 165.84623, 122],
  [-10.758843, 165.846273, 121.8],
  [-10.758939, 165.84623, 121],
  [-10.75902, 165.846155, 120],
  [-10.759102, 165.846058, 119],
  [-10.759197, 165.845983, 118],
  [-10.759317, 165.845951, 116.6],
  [-10.759451, 165.84594, 115.6],
  [-10.759587, 165.84594, 115],
  [-10.759724, 165.845919, 114.8],
  [-10.759856, 165.845908, 114.4],
  [-10.759986, 165.845876, 113.8],
  [-10.760115, 165.845833, 113],
  [-10.760239, 165.845768, 112],
  [-10.760367, 165.845704, 111],
  [-10.760502, 165.845661, 109.8],
  [-10.760644, 165.845672, 108.8],
  [-10.760787, 165.845704, 108],
  [-10.760933, 165.845704, 107.4],
  [-10.761065, 165.845768, 106.2],
  [-10.761183, 165.845865, 105],
  [-10.761304, 165.845951, 104.4],
  [-10.761428, 165.846047, 105.8],
  [-10.761553, 165.84609, 106.8],
  [-10.761684, 165.846101, 106.6],
  [-10.761813, 165.846123, 105.8],
  [-10.761944, 165.846101, 105],
  [-10.762081, 165.846101, 104.2],
  [-10.762219, 165.846101, 103.4],
  [-10.762354, 165.84609, 102.4],
  [-10.762474, 165.846015, 101.6],
  [-10.762546, 165.845886, 100.8],
];

export default stream;
